// extracted by mini-css-extract-plugin
export default {"container":"SimpleButton_container__QdGYD","greyButton":"SimpleButton_greyButton__SZzd2"};